/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react/style-prop-object */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from "react";
import { useInView } from "react-intersection-observer";

import useScrollToTop from "../../hooks/useScrollToTop";
import ObserverContext from "../../context/Observer";
import { I18nContext } from "../../context/I18nProvider";

import Translate from "../../i18n/Translate";

import ContactForm from "../../components/Contact/ContactForm";

import { SocialMedia } from "../../components/icons";

import {
  colorClaro,
  colorPrimario,
} from "../../assets/scss/variables/colors.module.scss";

const Contact = () => {
  // Scroll to top
  useScrollToTop();

  const { setActualComponent } = useContext(I18nContext);

  const { setElementInview } = useContext(ObserverContext);

  const [vision, inView] = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  // Detectamos el scroll del contenedor line
  const handleScroll = (e) => {
    e.preventDefault();

    const top = window.scrollY < 343;

    setElementInview(!top);
  };

  // Seteamos el componente actual, para las traduccion de rutas
  useEffect(() => {
    setActualComponent("contact");
  }, [setActualComponent]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section className="contact" ref={vision}>
      <div className="contact__image triangle right"></div>

      <div className="contact__image triangle left"></div>

      <div className="contact__container">
        <div>
          <h2>
            <Translate langkey="contact.title" />
          </h2>

          <p>
            <Translate langkey="contact.copy" />
          </p>
        </div>

        {/* Formulario */}
        <div className="contact__form">
          <ContactForm />
        </div>

        {/* Info Tower */}
        <div className="contact__info">
          <h4>
            <Translate langkey="contact.column1.copy" />
          </h4>
          <p>
            <Translate langkey="contact.column1.address" />
          </p>

          <h4>
            <Translate langkey="contact.column1.phone-text" />
          </h4>
          <p>
            <Translate langkey="contact.column1.phone" />
          </p>

          <h4>
            <Translate langkey="contact.column1.email-text" />
          </h4>
          <p>
            <Translate langkey="contact.column1.email" />
          </p>

          <SocialMedia
            fill={colorClaro}
            background={colorPrimario}
            fb
            ig
            lin
            tt
            yt
          />
        </div>

        {/* Sedes */}
        <div className="contact__headquarters">
          <h4>
            <Translate langkey="contact.column2.title" />
          </h4>

          <h5>TUCUMÁN</h5>
          <p>eugenio@towertravel.com.ar</p>
          <h5>ROSARIO</h5>
          <p> rosario@towertravel.com.ar</p>
          <h5>CÓRDOBA</h5>
          <p>cordoba@towertravel.com.ar</p>
          <h5>MENDOZA</h5>
          <p> reservas@tmtoperadora.com.ar</p>
          <h5>BAHÍA BLANCA</h5>
          <p>bahiablanca@towertravel.com.ar</p>
          <h5>LA PLATA</h5>
          <p>emilianojc@towertravel.com.ar</p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
